import * as React from 'react';
import { ProjectThemeData } from './project-theme-data';
import { defaultThemeColor } from './default-theme';

export const ProjectThemeContext = React.createContext<ProjectThemeData>(new ProjectThemeData(defaultThemeColor));

export const useProjectThemeContext = () => React.useContext(ProjectThemeContext);
